var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4619 5.22656H14.3336C14.7038 5.22656 15 5.52276 15 5.893V9.41557C15 10.759 13.9105 11.8486 12.567 11.8486H12.5564C11.213 11.8486 10.1234 10.759 10.1234 9.41557V5.57565C10.1128 5.38524 10.2715 5.22656 10.4619 5.22656Z",
    fill: "#5059C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0748 4.52815C13.9395 4.52815 14.6404 3.82721 14.6404 2.96256C14.6404 2.09791 13.9395 1.39697 13.0748 1.39697C12.2102 1.39697 11.5092 2.09791 11.5092 2.96256C11.5092 3.82721 12.2102 4.52815 13.0748 4.52815Z",
    fill: "#5059C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19802 4.52752C9.44826 4.52752 10.4618 3.514 10.4618 2.26376C10.4618 1.01352 9.44826 0 8.19802 0C6.94778 0 5.93427 1.01352 5.93427 2.26376C5.93427 3.514 6.94778 4.52752 8.19802 4.52752Z",
    fill: "#7B83EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2127 5.22656H4.82344C4.46378 5.23714 4.17817 5.53333 4.18875 5.893V9.91276C4.13585 12.0813 5.86012 13.8796 8.02867 13.9325C10.1972 13.8796 11.9109 12.0813 11.8686 9.91276V5.893C11.858 5.54391 11.5724 5.23714 11.2127 5.22656Z",
    fill: "#7B83EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.634699 3.1416H7.024C7.37308 3.1416 7.6587 3.42722 7.6587 3.7763V10.1656C7.6587 10.5147 7.37308 10.8003 7.024 10.8003H0.634699C0.285614 10.8003 0 10.5147 0 10.1656V3.7763C0 3.42722 0.285614 3.1416 0.634699 3.1416Z",
    fill: "url(#paint0_linear_1190_12)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52168 5.57496H4.2417V9.05523H3.42717V5.57496H2.15778V4.89795H5.52168V5.57496Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1190_12",
    x1: 1.3325,
    y1: 2.63845,
    x2: 6.33817,
    y2: 11.3081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A62C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4D55BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3940AB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default __webpack_public_path__ + "static/media/teams.9686295920a83e11090f6ca87b4451c8.svg";
export { ForwardRef as ReactComponent };